import React from 'react';
import Carousel from 'react-material-ui-carousel'
import CarouselCard from "./CarouselCard"
import useScreenOrientation from '../helpers/useScreenOrientation';

import { ScenarioData } from "../../data/scenario.data"

export default function ScenarioSelection({scenario, setScenario}: any) { //product

  const isLandscape = useScreenOrientation();

  const [scenarioList, setScenarioList] = React.useState<any>([]);
  const [scenarioIndex, setScenarioIndex] = React.useState(0);

  React.useEffect(() => {
    const scenarioData: any = ScenarioData()
    var scenario_list: any = [];
    for (let scenario of scenarioData) {
      if (scenario.active) //&& scenario.products.includes(product.id)
        scenario_list.push(scenario)
    }
    setScenarioList(scenario_list)
  }, []); //product

  React.useEffect(() => {
    const scenarioData: any = ScenarioData()
    for(let n = 0; n < scenarioData.length; n++){
      const scenarioItem = scenarioData[n]
      if(scenario.id === scenarioItem.id){
        setScenarioIndex(n)
      }
    }
  }, [scenario]);

  return (
    <div className="scenario-selector-container">
      <div className="scenario-selector-background">
        <div className={`scenario-selector-content ${isLandscape ? '' : 'portrait'}`}>
          <div className="scenario-selector-title">
            PROYECTOS
          </div>
          <div className="scenario-selector-title-underline"/>
          <Carousel index={scenarioIndex} className={`scenario-selector-carousel ${isLandscape ? '' : 'portrait'}`} animation="slide" duration={1000}
            navButtonsAlwaysVisible={true} autoPlay={false} fullHeightHover={false}
            navButtonsProps={{//size and color
              style: {
                width: '1.88rem',
                height: '1.88rem',
                backgroundColor: 'rgba(255,255,255,0.1)'
              }
            }}
            navButtonsWrapperProps={{//position
              style: {
                bottom: isLandscape ? '1rem' : '4rem',
                top: 'unset'
              }
            }}
            indicatorIconButtonProps={{
              style: {
                padding: '0.25rem',
                color: '#BCEBFF',
              }
            }}
            activeIndicatorIconButtonProps={{
              style: {
                color: '#14DAA0'
              }
            }}
            indicatorContainerProps={{
              style: {
                marginTop: isLandscape ? '0rem' : '0.5rem',
              }
            }}
          >
            {(scenarioList as {}[]).map((scenarioItem: any, index) => (
              <CarouselCard key={index} scenario={scenarioItem} setScenario={setScenario}/>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
}
